 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webpackJsonp"];
 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		88: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = "text/javascript";
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "./js/" + ({"0":"common-main","1":"ExploreNewInsight","2":"ExplorePackages","3":"PackageResult","4":"MyInsights","5":"OnboardingConnect","6":"Dashboard","7":"UserManagement","8":"ConnectYourApp","9":"PublicInsightPost","10":"OnboardingPaymentSubscription","11":"PaymentSubscription","12":"CreateNewCollection","13":"InsightCategories","14":"KpiManagement","15":"PaymentProPlan","16":"ShopifyLogin","17":"AppsumuLogin","18":"SignUp","19":"Login","20":"PaymentSuccess","21":"CustomizeInsight","22":"PaymentCancel","23":"Notifications","24":"Maintenance","25":"KPIDetail","26":"Logout","27":"common-Dashboard","28":"common-MyInsights","29":"common-CreateNewCollection","30":"AccountPlanUpgradePopup","31":"CreateNotificationPopUp","32":"common-KpiManagement","33":"RequestAnInsightPopup","34":"InsightDetailPopup","35":"PackageWarningPopup","36":"InsightSharePopUp","37":"common-ComponentTreeMapChart","38":"PackageLoadingPopupList","39":"common-UserManagement","40":"InsightsFilterMessage","41":"ComponentLineChart","42":"EditKPIPopup","43":"ThankYou","44":"InsightEditPopup","45":"PackageLoaderAnimation","46":"ConfirmDeleteKPIPopup","47":"CreateKPIPopup","48":"KPISearchFilter","49":"UpdateMemberPopUp","50":"AddNewMemberPopUp","51":"ComponentDataSourceChangePopup","52":"ExploreInsightsOnMyInsights","53":"CancelSubscriptionPopup","54":"InsightChartGraph","55":"ComponentGridChart","56":"ComponentAlerts","57":"xlsx.mini.min","58":"MemberCardMenu","59":"TabsComponent","60":"ChangeContactEmailPopup","61":"ComponentReAuthenticatePopup","62":"AddNewWebsitePopUp","63":"NotificationsEmptyScreen","64":"ComponentLoader","65":"ComponentKPIProgressBar","66":"InsightsSearchFilterList","67":"PackagePremiumBadge","68":"ComponentTreeMapChart","69":"DownloadTableData","70":"Alert","71":"TabComponent","72":"ConfirmDeleteMemberPopup","73":"AppsumoAccountUpgradePopup","74":"FormShopify","75":"FormGoogleSearchConsole","76":"FormGoogleAnalytics4","77":"FormGoogleAnalytics","78":"FormGoogleAdwords","79":"FormFacebook","80":"mermaid.min.css","81":"marked.js","82":"HighchartsTreemap","83":"HighchartsHeatMap","84":"HighchartsExporting","85":"gridjs","86":"dompurify","87":"chart.js"}[chunkId]||chunkId) + ".bundle.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 200);



// WEBPACK FOOTER //
// webpack/bootstrap f0b1fc77fa40ec1b4de7